import { SxProps, Theme } from '@mui/material';

export const CompleteDataButtonSX: SxProps<Theme> = {
	marginTop: 1,
	textTransform: 'none !important',
};
